"use client";
import { getBrowserSupabaseClient as getSharedClient } from "@wtc/supabase";

// Shared singleton Supabase browser client for all apps
// This ensures we never spawn multiple GoTrueClient instances across packages/apps

let cachedBrowserClient: any | null = null;

export function getBrowserSupabaseClient() {
  if (cachedBrowserClient) return cachedBrowserClient;

  if (typeof window !== "undefined") {
    try {
      const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
      const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
      console.log("🧩 [UI] Supabase browser client init", {
        hasUrl: !!url,
        hasKey: !!key,
        urlHost: (() => {
          try {
            return url ? new URL(url).host : null;
          } catch {
            return null;
          }
        })(),
        keyPrefix: key ? String(key).slice(0, 6) : null,
      });
    } catch {}
  }

  cachedBrowserClient = getSharedClient();

  return cachedBrowserClient;
}


